<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" :items="items" class="mc-page-three" />
    </div>
    <div class="mc-liveview clearfix">
      <GoogleMap />
      <SideBar />
    </div>
  </Layout>
</template>
<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import GoogleMap from './GoogleMap'
import SideBar from './SideBar'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Route',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    SideBar,
    GoogleMap,
  },

  data() {
    return {}
  },

  computed: {
    isAdding() {
      return typeof this.$route.params.id === 'undefined'
    },

    title() {
      return this.isAdding ? this.$t('master.ruteBaru') : this.$t('master.ubahRute')
    },

    items() {
      return [
        {
          text: this.$t('menuitems.masterData.text'),
          to: '/master',
        },
        {
          text: this.$t('master.rute'),
          to: '/master/route',
        },
        {
          text: this.isAdding ? this.$t('master.ruteBaru') : this.$t('master.ubahRute'),
        },
      ]
    },
  },
}
</script>
